// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__36w_C","header":"ClearentDisclaimer_header__2sQCu","inner":"ClearentDisclaimer_inner__3PH3j"};